export const nextAll = (el: HTMLElement, selector: string) => {
  const nextEls: HTMLElement[] = []
  let next = el.nextElementSibling as HTMLElement
  while (next) {
    if (!selector || next.matches(selector)) nextEls.push(next)
    next = next.nextElementSibling as HTMLElement
  }
  return nextEls
}